import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const Header = styled.h2`
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 8px;
  margin-top: 44px;

  @media (${mediaQuery.tablet}) {
    padding-left: 16px;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 24px;
  @media (${mediaQuery.tablet}) {
    padding-left: 16px;
  }
`;
